import { render, staticRenderFns } from "./AcquirerCostConfigMaintain.vue?vue&type=template&id=2b9c6287&scoped=true&"
import script from "./AcquirerCostConfigMaintain.vue?vue&type=script&lang=js&"
export * from "./AcquirerCostConfigMaintain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9c6287",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b9c6287')) {
      api.createRecord('2b9c6287', component.options)
    } else {
      api.reload('2b9c6287', component.options)
    }
    module.hot.accept("./AcquirerCostConfigMaintain.vue?vue&type=template&id=2b9c6287&scoped=true&", function () {
      api.rerender('2b9c6287', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/settings/financial/acquirer-cost-config/AcquirerCostConfigMaintain.vue"
export default component.exports